jQuery.noConflict();
(function( $ ) {
    $(function() {
//Document Ready STARTS

        var wc = [];
        wc.mobileWidth = 640;
        wc.debug = false;
        wc.afterLoad = false;
        var wcxhr = null

        $(window).on('load', function(){
            wcLoad();
        });

        function wcLoad(){
            scAddFilterToggles();
            openShippingNotification();
            toggleYith();
            productEq();
            wc.afterLoad = true;
        }

        $(window).on('resize', function(){
            productEq();
        });

        $(window).on('sc_ajax_sliders_ready', function(){
            productEq();
        });

        function productEq(){
            eqSelectedDivs('.product .loop-product-wrap .bulkeq');
            eqSelectedDivs('.product .loop-product-wrap .loop-product-title');
            eqSelectedDivs('.product .loop-product-wrap');
        }

        function eqSelectedDivs(selector) {
            $(selector).attr('style', '');
            var maxHeight = Math.max.apply(null, $(selector).map(function () {
                return $(this).outerHeight();
            }).get());
            if (selector == '.product .loop-product-wrap .bulkeq') {
                var width = $(selector).width();
                if (width > 256) {
                    maxHeight = maxHeight - 20;
                }
            }
          //  console.log(selector +' + '+maxHeight);
            $(selector).attr('style', 'max-height: '+maxHeight+'px; height: '+maxHeight+'px;');
        }

        setTimeout(function(){
            if (wc.afterLoad == false) {
                wcLoad();
            }
        }, 3000);

        $('body').on('click', '.loop-basket-add button', function(e){
            e.preventDefault();
            if (!$(this).hasClass('disabled')) {
                var parent = $(this).parent(),
                    qty = parent.find('input[class=qty]').val(),
                    product_id = parent.find('input[class=product_id]').val(),
                    product_sku = parent.find('input[class=product_sku]').val(),
                    item_key = parent.find('input[class=basket_key').val();
                $('.loop-basket-add button').addClass('disabled');
                if ($(this).hasClass('sc-cart-update') && item_key != 0) {
                    // console.log('Run product update => '+product_id+'('+qty+') ['+item_key+']');
                    sc_update_basket(item_key, qty, product_id);
                }
                else {
                    // console.log('Product '+product_id+'('+qty+') to basket');
                    var product = {product_sku: product_sku, product_id: product_id, quantity: qty};
                    sc_add_to_cart(product);
                }
            }
        });

        function scAddFilterToggles(){
            if ($('.widget_yith-woocommerce-ajax-navigation-filters').length>0) {
                $.each($('.yith-wcan-filters .yith-wcan-filter'), function(){
                    $(this).find('.filter-title').append('<span class="yith-toggle"></span>');
                    $(this).find('.filter-content').attr('style', 'display: none;');
                });

                $('h4.filter-title').on('click', function(){
                    $(this).parent().toggleClass('opened');
                    $(this).parent().find('.filter-content').slideToggle();
                });
            }
        }

        // Filter Featured Brands sidebar widget based on brand list below (after page load)
        if ( $('.yith-wcan-filter[data-taxonomy="filter_brand"]').length > 0 ) {
            $('.widget ul.top-brands li a').each(function() {
                var brand = $(this).text().toLowerCase().trim(),
                    match = false;
                $('.yith-wcan-filter[data-taxonomy="filter_brand"] ul li a').each(function() {
                    var filter = $(this).text().toLowerCase().trim();
                    if (filter == brand) {
                        match = true;
                        return false;
                    }
                });
                if (!match) {
                    $(this).closest('li').remove();
                }
            });
            if ( $('.widget ul.top-brands li').length < 1 ) {
                $('.widget ul.top-brands').closest('.widget').remove();
            }
        }

        // Filter Categories widget based on current category
        /*if ( $('.yith-wcan-filter[data-taxonomy="product_cat"]').length > 0 && $('body').attr('class').indexOf('term-') >= 0 ) {
            var classes = $('body').attr('class').split(' '),
                termId = false;
            
            for ( var i=0; i < classes.length; i++ ) {
                if ( classes[i].substring(0, 5) == 'term-' ) {
                    var term = classes[i].substring(5);
                    if ( !isNaN(term) ) {
                        termId = term;
                        break;
                    }
                }
            }
            if (termId != false) {
                var $tree = $('.yith-wcan-filter[data-taxonomy="product_cat"] input[id$=' + termId + ']').closest('.filter-item');
                if ( $tree.length > 0 ) {
                    $('.yith-wcan-filter[data-taxonomy="product_cat"] .filter-item').hide();
                    $tree.show();
                    $tree.find('li.filter-item').show();
                    $tree.parent().closest('.filter-item.level-1').show();
                    $tree.closest('.filter-item.level-0').show();
                }
            }
        }*/
        if ( $('.yith-wcan-filter[data-taxonomy="product_cat"]').length > 0 && window.location.href.indexOf('/product-category/') >= 0 ) {
            // Get parent category slug from URL
            var parentSlug = window.location.href.substring( window.location.href.indexOf('/product-category/') + 18 );
            parentSlug = parentSlug.substring( 0, parentSlug.indexOf('/') );

            // Loop through filters trying to find parent category
            $('.yith-wcan-filter[data-taxonomy="product_cat"] li.level-0 > label > a').each(function() {
                var slug = $(this).text().trim().toLowerCase().replace('& ', '').replace(/ /g, '-');
                if (slug == parentSlug) {
                    $('.yith-wcan-filter[data-taxonomy="product_cat"] li.level-0').hide();
                    $(this).closest('li.level-0').show();
                    return false;
                }
            });
        }

        // SC WC filter sidebar attributes, used with product filter below
        function sc_wc_filter_sidebar(counts) {

            //$('.sc-wc-filters ul.filters li .count').text('(0)');
            $('.sc-wc-filters ul.filters li').show();
            var hasAnyFilters = ( $('.sc-wc-filters ul.filters').find('li input:checked').length !== 0 );

            if (hasAnyFilters) {
                $('.sc-wc-filters .clear-all').removeClass('hide').show();
            } else {
                $('.sc-wc-filters .clear-all').hide();
            }

            $('.sc-wc-filters ul.filters').each(function() {
                var hasFilters = ( $(this).find('li input:checked').length !== 0 );

                $(this).find('li input').each(function() {
                    var $input = $(this),
                        termId = $input.val();
                    if ( typeof( counts[termId] ) == 'undefined' ) {
                        if (hasAnyFilters) {
                            $input.closest('li').hide();
                        }
                    } else {
                        $input.closest('li').show();
                        $input.closest('li').find('.count').text( '(' + counts[termId] + ')' );
                    }
                });
            });
        }

        // SC WC category filter AJAX
        function sc_wc_filter_products() {

            var catId = $('.sc-wc-filters').data('cat-id');
            if ( catId == undefined || catId == '' ) {
                //return false;
                catId = false;
            }

            var data = { 
                action: 'sc_wc_filter_products', 
                wc_cat_id: catId, 
                sort_by: $('select.orderby').val(),
                per_page: $('select.sortby').val(),
                terms: {} 
            };

            $('.sc-wc-filters .filter-outer').each(function() {
                var $checked = $(this).find('input:checked'),
                    taxName = $(this).data('tax');
                if ( $checked.length > 0 ) {
                    data.terms[taxName] = [];
                    $checked.each(function() {
                        data.terms[taxName].push( parseInt( $(this).val() ) );
                    });
                }
            });

            if ( wcxhr != null ) {
                wcxhr.abort();
                wcxhr = null;
            }
            wcxhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: 'POST',
                cache: false,
                data: data,
                beforeSend: function() {
                    $('.products-loop').append('<div class="spinner"><div class="lds-dual-ring"></div></div>').addClass('loading');
                },
                success: function(result) {
                    var data = decodeJSON(result);
                    $('.shop-loop-wrap .products-loop').html(data.html);
                    $('.products-loop').removeClass('loading');
                    $('.spinner').remove();

                    if ( Object.keys(data.counts).length > 0 ) {
                        sc_wc_filter_sidebar(data.counts);
                    } else {
                        $('.sc-wc-filters ul.filters li').show();
                    }
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }
        $('.sc-wc-filters .submit .button').click(function() {
            sc_wc_filter_products();
        });
        if ( $('.sc-wc-filters .submit .button').length > 0 ) {
            sc_wc_filter_products();
        }
        if ( $('.sc-wc-filters').length > 0 ) {
            $('.woocommerce-ordering select').removeAttr('onchange').change(function(e) {
                e.preventDefault();
                sc_wc_filter_products();
                return false;
            });
            // Featured Brands support (custom feature)
            $('.shop-loop-wrap .top-brands li a').click(function(e) {
                var termId = $(this).data('term-id'),
                    $filter = $('.filter-outer[data-tax="pa_brand"] .filters li input[value="' + termId + '"]');

                if ( $filter.length === 1 ) {
                    e.preventDefault();
                    $('.filter-outer[data-tax="pa_brand"] .filters li input').prop('checked', false);
                    $filter.prop('checked', true);
                    sc_wc_filter_products();
                    return false;
                }
            });
        }

        // Clear all filters
        $('.sc-wc-filters .clear-all a').click(function(e) {
            e.preventDefault();
            $('.sc-wc-filters ul.filters li input:checked').prop('checked', false);
            $('.sc-wc-filters ul.filters li').show();
            sc_wc_filter_products();
            return false;
        });

        function sc_update_basket(basket_key, qty, product_id) {
            if ( wcxhr != null ) {
                wcxhr.abort();
                wcxhr = null;
            }
            wcxhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: 'POST',
                cache: false,
                data: ({
                    action: 'sc_cart_update',
                    item_key: basket_key,
                    qty: qty,
                    product_id: product_id,
                }),
                beforeSend: function() {
                },
                success: function(data) {
                   // console.log(data);
                    var fragments = decodeJSON(data);
                    wc.fragments = fragments;
                    wc.basket_items = fragments['basket_map'];
                    redrawProductActions();
                    $('.wc-links .cwl.basket .items-num').remove();
                    $('div.widget_shopping_cart_content').remove();
                    $('.wc-links .cwl.basket').append('<div class="items-num">'+fragments['basket_items']+'</div>');
                    $('.wc-links .cwl.basket a').append('<div class="widget_shopping_cart_content">'+fragments['div.widget_shopping_cart_content']+'</div>');
                    if (fragments['max_lead'] != undefined) {
                        slideNotification('Your basket updated. <br/> Please note the lead time for this product is ' + fragments['max_lead']  + ' days and so next day shipping will not be available.', 10000);
                    }
                    else {
                        slideNotification('Your basket updated');
                    }

                 //   console.log(fragments['basket_items']);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function sc_add_to_cart(product) {
            if ( wcxhr != null ) {
                wcxhr.abort();
                wcxhr = null;
            }
            wcxhr = $.ajax({
                url: ajax_wc,
                timeout: 12000,
                type: 'POST',
                cache: false,
                data: product,
                beforeSend: function() {
                },
                success: function(data) {
                  //  console.log(data);
                    var fragments = data['fragments'];
                    var basket_map = fragments['basket_map'];
                    wc.fragments = fragments;
                    wc.basket_items = basket_map;
                    redrawProductActions();
                    $('.wc-links .cwl.basket .items-num').remove();
                    $('div.widget_shopping_cart_content').remove();
                    $('.wc-links .cwl.basket a').append('<div class="items-num">'+fragments['basket_items']+'</div>');
                    $('.wc-links .cwl.basket').append('<div class="widget_shopping_cart_content">'+fragments['div.widget_shopping_cart_content']+'</div>');
                    if (fragments['max_lead'] != undefined) {
                        slideNotification('Your basket updated. <br/> Please note the lead time for this product is ' + fragments['max_lead']  + ' days and so next day shipping will not be available.', 10000);
                    }
                    else {
                        slideNotification('Your basket updated');
                    }
                   // console.log(fragments['basket_items']);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function scCartRefresh(){
            if ( wcxhr != null ) {
                wcxhr.abort();
                wcxhr = null;
            }
            wcxhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: 'POST',
                cache: false,
                data: ({
                    action: 'sc_cart_refresh'
                }),
                beforeSend: function() {
                },
                success: function(data) {
                   // console.log(data);
                    var fragments = decodeJSON(data)
                    wc.fragments = fragments;
                    wc.basket_items = fragments['basket_map'];
                    redrawProductActions();
                    $('.wc-links .cwl.basket .items-num').remove();
                    $('div.widget_shopping_cart_content').remove();
                    $('.wc-links .cwl.basket').append('<div class="items-num">'+fragments['basket_items']+'</div>');
                    $('.wc-links .cwl.basket a').append('<div class="widget_shopping_cart_content">'+fragments['div.widget_shopping_cart_content']+'</div>');
                    if (fragments['max_lead'] != undefined) {
                        slideNotification('Your basket updated. <br/> Please note the lead time for this product is ' + fragments['max_lead']  + ' days and so next day shipping will not be available.', 10000);
                    }
                    else {
                        slideNotification('Your basket updated');
                    }

                   // console.log(fragments['basket_items']);
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }

        function redrawProductActions(){
            $('.loop-basket-add button').removeClass('disabled');
            if (wc.basket_items != undefined && $('.loop-basket-add').length > 0) {
                var items = wc.basket_items;
                if (items.length != 0) {
                    $('.loop-basket-add').removeClass('inbasket');
                    $('.loop-basket-add input.qty').val(1);
                    $.each(items, function(pid, dt){
                        if ($('input[name="basket_key['+pid+']"]').length>0) {
                            $('input[name="basket_key['+pid+']"]').parent().addClass('inbasket');
                            $('input[name="qty['+pid+']"]').val(dt['quantity']);
                            $('input[name="basket_key['+pid+']"]').val(dt['item_key']);
                        }
                    });
                }
            }
        }

        $('body').on('click', '.bulk-save', function(e){
            e.preventDefault();
            var pid = $(this).attr('data-pid');
            if (pid != undefined && pid != '') {
                getBulkDisc(pid);
            }
        });

        function getBulkDisc(pid) {
            if ( wcxhr != null ) {
                wcxhr.abort();
                wcxhr = null;
            }
            wcxhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: 'POST',
                cache: false,
                data: ({
                    action: 'sc_bulk_disc',
                    pid: pid,
                }),
                beforeSend: function() {
                },
                success: function(data) {
                //   console.log(data);
                    if ($('#pop-reveal').length>0) {
                        $('#pop-content').html(data);
                        $('#pop-reveal').foundation('open');
                    }
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }


        $( document.body ).on('updated_cart_totals', function(fragments, cart_hash, button){
            scCartRefresh();
        });

        $( document.body ).on('removed_from_cart', function(event, fragments, cart_hash){
            scCartRefresh();
        });

        $( document.body ).on('wc_cart_button_updated', function(fragments, cart_hash, button){
            scCartRefresh();
        });

        $('.filters-toggle').on('click', function(){
            $('body').toggleClass('filter-on');
        });

        $('.mobile-filter-toggle').on('click', function(){
            $('.filters-toggle').trigger('click');
        });



        function openShippingNotification(){
            if ($('#checkout-pop').length>0) {
                $('#place_order').addClass('disabled');
                $('#checkout-pop').foundation('open');
            }
        }

        $('#checkout-msg-ok').on('change', function(){
            $('.button.close-pop').toggleClass('disabled');
        });

        $('.checkout-pop-content .button.close-pop').on('click', function(){
            if (!$(this).hasClass('disabled')) {
                closeShippingNotification();
            }
        });

        function closeShippingNotification(){
            $('#place_order').removeClass('disabled');
            $('#checkout-pop').foundation('close');
        }

        function slideNotification(msg, delay) {
            delay ? delay : 5000;
            $('.slide-notification').remove();
            var notification = '<div class="slide-notification"><p>'+msg+'</p><div class="close-notification" title="Close"></div></div>';
            $('body').append(notification);
            setTimeout(function(){$('.slide-notification').addClass('in-view');},300);
            setTimeout(function(){hideSlideNotification();}, delay);
        }

        function hideSlideNotification(){
            $('.slide-notification').removeClass('in-view');
            setTimeout(function(){ $('.slide-notification').remove()}, 1200);
        }

        function toggleYith() {
         //.yith-wcan-filter.checkbox-design .filter-item label input:checked~a:before
            $.each($('.filters-container .yith-wcan-filter'), function(){
                var selected = $(this).find('input:checked').length;
                if (selected > 0) {
                    $(this).find('.filter-title').trigger('click');
                }
            });
        }


        $(window).ajaxComplete(function(data, s, z) {
            if (z.headers != undefined) {
                setTimeout(function(){
                    $(window).trigger('resize');
                }, 500)
            }
        });

        $( document.body ).on( 'Searchanise.ResultsUpdated', SearchResultsUpdated );
        function SearchResultsUpdated(){
            console.log('SearchResultsUpdated');
        }

//Document Ready ENDS
});
})(jQuery);